import { render, staticRenderFns } from "./SiteInfo.vue?vue&type=template&id=fda33420&scoped=true&"
import script from "./SiteInfo.vue?vue&type=script&lang=js&"
export * from "./SiteInfo.vue?vue&type=script&lang=js&"
import style0 from "./SiteInfo.vue?vue&type=style&index=0&id=fda33420&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda33420",
  null
  
)

export default component.exports